import React 					from  	'react';
import moment 					from 	'moment';
import Checkbox 				from 	'material-ui/Checkbox';
import DataFeedActions 			from 	'../actions/DataFeedActions';

function getCurrentState( props ) {


	return {	

		checked 	: 	props.checked,
		col 		: 	props.col,
		row 		: 	props.rowIndex,
		data 		: 	props.data
	}
}

var RemoveFromPileCheckbox = React.createClass({

	getInitialState : function() {

		let currentState 		= getCurrentState( this.props );

		return currentState;
	},

	componentWillReceiveProps : function( newProps ) {

		this.setState( getCurrentState( newProps ) );
	},

	shouldComponentUpdate : function( nextProps, nextState ) {

		return true;
	},

	render : function() {

		const orgID 	= this.state.data.getObjectAt( this.state.row )[this.state.col];

		const checked 	= ( this.state.checked[orgID] === 0 ) ? true : false;

		return (

			<div style={{ textAlign : 'right' }}>
				<Checkbox checked={checked} id={orgID} onCheck={ () => this._removeFromPile( orgID ) } />
			</div>
		);
	},

	_removeFromPile : function( orgID ) {

		DataFeedActions.removeFromPile( orgID );
	}
});

export default RemoveFromPileCheckbox;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/RemoveFromPileCheckbox.react.js